export default __webpack_public_path__ + "static/media/tr_7.f0b87eb1.mp3";